import React, { useCallback, useState } from 'react';
import styled from 'styled-components';
import { Button, Drawer, Row, Col } from 'antd';
import { AddClassForm } from './AddClassForm';
import { FormattedMessage } from 'react-intl';

const StyledAddButton = styled(Button)`
  background: transparent;
  padding: 0;
  border: none;
  color: #8053d7;
  outline: none;
  box-shadow: none;
  margin-left: 10px;

  &:hover,
  &:focus,
  &:active {
    color: #9874df;
    background: transparent;
    outline: none;
    box-shadow: none;
  }
`;

export const AddClassDrawer = ({ students }) => {
  console.log('AddClassDrawer');
  const [visible, setVisible] = useState(false);

  const showDrawer = useCallback(() => {
    console.log('AddClassDrawer#showDrawer clicked');
    setVisible(true);
  }, []);

  const onClose = useCallback(() => {
    console.log('AddClassDrawer#onClose clicked');
    setVisible(false);
  }, []);

  return (
    <>
      <StyledAddButton onClick={showDrawer}><FormattedMessage id="classes-dashboard.main.create-class-button"/></StyledAddButton>
      <Drawer
        title='Add Class'
        placement='right'
        width={window.innerWidth > 700 ? 700 : window.innerWidth}
        onClose={onClose}
        visible={visible}
      >
        <Row gutter={[{ xs: 8, sm: 16, md: 24, lg: 32 }, 16]}>
          <Col xl={24}>
            <AddClassForm
              onClose={onClose}
              unEnrolledStudents={students}
              isActive={visible}
            />
          </Col>
        </Row>
      </Drawer>
    </>
  );
};
